import { Navigate, useLocation } from 'react-router-dom';
import { useFeatureFlag, FeatureFlag } from '@lingugeek/ui';
import type { ReactNode } from 'react';

interface FeatureFlagGuardProps {
  children: ReactNode;
  flag: FeatureFlag;
  redirectTo?: string;
  fallback?: ReactNode;
}

/**
 * Guard component that protects routes based on feature flags
 */
export default function FeatureFlagGuard({
  children,
  flag,
  redirectTo = '/',
  fallback,
}: FeatureFlagGuardProps) {
  const { isEnabled } = useFeatureFlag(flag);
  const location = useLocation();

  if (!isEnabled) {
    if (fallback) {
      return <>{fallback}</>;
    }

    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
